<template>
  <div class="main">
    <div class="scroll-box" ref="scrollBox">
      <main class="content">
        <red-packet-conf 
          ref="redPacketRef" 
          v-model="additionalForm.redPacket"
          :sourceType="2"
          :totalAmount="walletBalance"
          :isConfigured="isConfigured"
          :createdTime="createdTime"
          />
        <fission-commission 
          v-model="additionalForm.fission" 
          :sourceType="2"
          :isConfigFission="isConfigFission"
          :createdTime="createdTime"
        />
        <ranklist-conf 
          v-model="additionalForm.rankList" 
          :rankData.sync="virtualData"
          :sourceType="2"
        />
        <div class="matter-text">
          注意事项：<br>
          1. 微信充值将会收取一定的手续费<br>
          2. 剩余红包将在活动截止后原路退回<br>
        </div>
      </main>
    </div>
    <footer>
      <div class="footer-btn plain" @click="goBack">返回</div>
      <div class="footer-btn plain" @click="redirectTo">活动充值</div>
      <div class="footer-btn plain" @click="downloadData">数据下载</div>
      <div class="footer-btn " @click="save">保存</div>
    </footer>
  </div>
</template>

<script>
import RedPacketConf from './components/red-packet-conf'
import FissionCommission from './components/fission-commission'
import redPackMixin from './mixins/red-packet'
import ranklistConf from './components/ranklist-conf'
import loadingMixin from '@/mixins/loading-mixin'
import {wxPay} from '@/utils/wxPay'
import { getFissionDTO,initFissionForm } from './utils'
export default {
  name: 'AdditionalActivity',
  mixins: [redPackMixin, loadingMixin],
  components: {
    RedPacketConf,
    FissionCommission,
    ranklistConf
  },
  computed: {
    is365() {
      return this.$cache.is365()
    }
  },

  data() {
    return {
      additionalForm: {
        redPacket: {
          boolShowRedPacket: false,
          boolAreaLimited: false,
          redPacketType: 1,
          singleAmount: '',
          totalAmount: '',
          ranges: [
            {
              startAmount: '',
              endAmount: '',
              percent: ''
            }
          ]
        },
        fission: {},
        rankList: {}
      },
      activityId: '',
      // 是否已经配置了红包参数，默认已配置，只读展示
      isConfigured: true,
      walletBalance: 0,
      // 是否已经配置了裂变参数，默认已配置，只读展示
      isConfigFission: true,
      virtualData: {},
      withdrawConfig: {},
      createdTime: null
    }
  },
  methods: {
    async init() {
      this.showLoading();
      await this.getRedPacketConf();
      // 检查是否配置了红包 裂变
      this.checkIsConfigured();
      this.hideLoading();
    },
    getRedPacketConf() {
      if (!this.$route.query.activityId) {
        return;
      }
      return this.$api.activityMgmt.getAdditionalConfById(this.$route.query.activityId)
        .then(({data}) => {
          const {activityId, activityAppend, walletBalance, createdTime = new Date().getTime()} = data;
          this.activityId = activityId;
          this.walletBalance = walletBalance || 0;
          this.additionalForm.redPacket = this.initRedPacketForm(activityAppend || []);
          this.additionalForm.fission = initFissionForm(activityAppend || [], 'fission');
          this.additionalForm.rankList = initFissionForm(activityAppend || [], 'rankList');
          this.virtualData = data.virtualDataVO || {},
          this.createdTime = createdTime
        })
        .catch(err => {
          console.log(err);
        });
    },
    checkIsConfigured() {
      const {redPacketType, totalAmount, singleAmount, ranges} = this.additionalForm.redPacket;
      const { boolFissionRewardEnabled } = this.additionalForm.fission
      if (redPacketType == 1) {
        this.isConfigured = +totalAmount > 0 && +singleAmount > 0;
      } else if (redPacketType == 2) {
        this.isConfigured = ranges && ranges.length > 0;
      }
      // 是否配置了裂变
      this.isConfigFission = boolFissionRewardEnabled
    },
    goBack() {
      this.$router.go(-1);
    },
    redirectTo() {
      const {openRechargeAndWithdraw, time} = this.withdrawConfig
      const isNewActive = new Date(this.createdTime).getTime() > new Date(time).getTime()
      if (openRechargeAndWithdraw === 'false' && isNewActive) {
        this.$dialog.alert({
          title: '提示',
          message: '系统维护中当前不可活动充值',
        })
          .then(() => {
            // on confirm
          })
        return
      }
      this.$router.push({
        path: '/activity-recharge',
        query:  this.$route.query
      })
    },
    checkValid() {
      // 附加活动：红包
      const redPacketRef = this.$refs.redPacketRef;
      if (redPacketRef && !redPacketRef.checkValid()) {
        return false;
      }

      return true;
    },
    save() {
      if (!this.checkValid()) {
        return;
      }
      const { boolVirtualData,boolRankList } = this.additionalForm.rankList
      if ((boolVirtualData && boolRankList) && JSON.stringify(this.virtualData) == '{}') {
        this.$toast('请先生成虚拟数据');
        return
      }
      const params = {
        flag: this.is365 ? 2 : 1,
        activityId: this.activityId,
        activityAppend: [
          {
            activityId: this.activityId,
            appendName: 'redPacket',
            activityAppendElement: this.getRedPacketDTO(this.additionalForm.redPacket)
          },
          {
            activityId: this.activityId,
            appendName: 'fission',
            activityAppendElement: getFissionDTO(this.additionalForm.fission)
          },
          {
            activityId: this.activityId,
            appendName: 'rankList',
            activityAppendElement: getFissionDTO(this.additionalForm.rankList)
          }
        ]
      };
      this.$api.activityMgmt.saveRedPacketConf(params)
        .then(async ({data}) => {
          if (data.orderNo) {
            data.source = 'additional'
            await wxPay(data)
            .catch(err => {
              console.log(err);
            })
          }
          this.$toast('保存成功');
          setTimeout(()=>{
            this.init();
          },2000)
        });
    },
    downloadData() {
      this.$api.activityMgmt.dataExport({type: 5,activityId: this.activityId})
        .then(res => {
          if (res.success) {
            this.$dialog.confirm({
              title: '下载提示',
              message:`因数据较大正在处理中，请稍后到<br/>我的-导出列表中下载数据`,
              cancelButtonText: '确定',
              confirmButtonText: '去往-导出列表'
            }).then(_ =>{
              this.$router.push({
                path: '/export-list'
              })
            })
          }
        })
    },
    queryPublicityData(){
      this.$api.h5.queryPublicityData('wx_withdraw_config')
        .then(res => {
          if (res.success && res.data) {
            const {openRechargeAndWithdraw, time} = res.data
            this.withdrawConfig = {openRechargeAndWithdraw,time}
          }
          
        })
    }
  },
  created() {
    this.init();
    this.queryPublicityData()
  }
}
</script>

<style lang="stylus" scoped>
.main
  .scroll-box
    height: calc(100vh - 64px)
    // height: 100vh
    overflow-y auto
    &::-webkit-scrollbar
      display: none

  footer
    box-sizing: border-box
    position fixed
    left 0
    bottom 0
    z-index 999
    padding 0 10px
    height 64px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    background-color #fff

    .footer-btn
      padding 10px 20px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    .footer-btn-s
      padding 10px 15px
    .plain
      color $mainTextColor
      background-color: #fff
  .matter-text {
    line-height 1.5
    margin: 20px;
    font-size: 12px;
  }
</style>